var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tourList"},_vm._l((_vm.tours),function(tour){return _c('div',{key:tour.code},[_c('tour-cassette',{attrs:{"tour":tour,"make-detail-page-url":_vm.makeDetailPageUrl(tour.sale_type),"mobile":_vm.mobile,"duration-tabs":_vm.shouldShowTabsFor(tour)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }